module.exports = __webpack_public_path__ + "static/financial_access8-0bd688ee74053580a43926c49c0419e0.png";